import { createMemo, For, Show, type JSX } from 'solid-js'

import Css from './charts.module.scss'

/**
 * Barras HORIZONTAIS, uma linha por categoria.
 *
 * Deitadas porque o rotulo e um nome ("Corrida ao ar livre", "Ciclismo indoor"), e
 * nome em barra vertical vira texto girado ou cortado. Deitado, o rotulo tem a
 * largura que quiser e a comparacao continua de relance.
 */
export function HorizontalBars(props: {
    rows: { label: string; values: { name: string; value: number; color: string }[] }[]
    format?: (value: number) => string
}): JSX.Element {
    const format = (value: number) => (props.format ?? ((v: number) => String(v)))(value)

    const max = createMemo(() => Math.max(1, ...props.rows.flatMap((row) => row.values.map((entry) => entry.value))))

    const legend = () => props.rows[0]?.values ?? []

    return (
        <div class={Css.horizontal}>
            <Show when={props.rows.length > 0} fallback={<p class={Css.horizontalEmpty}>Sem dado no período</p>}>
                <div class={Css.horizontalBody}>
                    <For each={props.rows}>
                        {(row) => (
                            <div class={Css.horizontalRow}>
                                <span class={Css.horizontalLabel} title={row.label}>
                                    {row.label}
                                </span>

                                <div class={Css.horizontalBars}>
                                    <For each={row.values}>
                                        {(entry) => (
                                            <div class={Css.horizontalItem}>
                                                <div
                                                    class={Css.horizontalBar}
                                                    style={{
                                                        width: `${Math.max(entry.value === 0 ? 0 : 1, (entry.value / max()) * 100)}%`,
                                                        'background-color': entry.color
                                                    }}
                                                />
                                                <span class={Css.horizontalValue}>{format(entry.value)}</span>
                                            </div>
                                        )}
                                    </For>
                                </div>
                            </div>
                        )}
                    </For>
                </div>
            </Show>

            <div class={Css.legend}>
                <For each={legend()}>
                    {(entry) => (
                        <span class={Css.legendItem}>
                            <span class={Css.legendSwatch} style={{ 'background-color': entry.color }} />
                            <span class={Css.legendName}>{entry.name}</span>
                        </span>
                    )}
                </For>
            </div>
        </div>
    )
}
